<template>

    <div class="selector" v-click-outside="hideMenu">
        <div class="selector-toggle" @click="show = !show">
            <span>{{ selectedItem.title }}</span>
            <div class="arrow"><i class="fas fa-chevron-down"></i></div>
        </div>
        <div v-if="show" class="selector-menu">
            <div v-if="searchable" class="selector-searchbar">
                <v-searchbar :model="query" @input="query = $event" />
            </div>
            <div class="selector-item" :class="{ active: item.value === val }" v-for="item in filteredItems" :key="item.value" @click="selectItem(item.value)">
                <div class="title">{{ item.title }}</div>
                <div v-if="item.desc" class="desc" v-html="item.desc" />
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .selector {
        position: relative;
        width: 100%;
    }

    .selector-toggle {
        @include font-medium(13px);
        align-items: center;
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 3px;
        cursor: pointer;
        display: flex;
        font-size: 13px;
        height: 50px;
        justify-content: space-between;
        overflow: hidden;
        padding: 0 50px 0 15px;
        position: relative;
        transition: .3s border-color;
        user-select: none;
        white-space: nowrap;
        &:hover {
            border-color: $color-text;
        }
        span {
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .arrow {
            display: grid;
            font-size: 11px;
            height: 50px;
            position: absolute;
            pointer-events: none;
            place-items: center;
            right: 0;
            top: 0;
            width: 50px;
        }
    }

    .selector-menu {
        @include shad(2);
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 5px;
        left: 0;
        margin-top: 52px;
        max-height: 300px;
        overflow: auto;
        padding: 10px 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 100;
    }

    .selector-searchbar {
        padding: 0 10px 5px 10px;
    }

    .selector-item {
        @include font-medium(13px);
        color: $color-text;
        cursor: pointer;
        display: block;
        padding: 8px 15px;
        transition: all .3s;
        user-select: none;
        &:hover {
            background-color: $color-highlight;
            .title { color: $color-primary };
        }
        &.active {
            .title { color: $color-primary };
        }
        .desc {
            @include font-medium(12px);
            color: $color-text-secondary;
            margin-top: 2px;
        }
    }

</style>

<script>

import ClickOutside from 'vue-click-outside';

export default {

    directives: {
        ClickOutside,
    },

    props: {
        model: {
            required: true,
        },
        size: {
            type: String,
            default: 'md',
        },
        items: {
            required: Array,
            default: [],
        },
        nullable: {
            type: Boolean,
            default: true,
        },
        searchable: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            show: false,
            query: '',
            val: this.model ? this.items.find(i => i.value === this.model).value : '',
        }
    },

    computed: {

        selectedItem() {
            let item = this.items.find(i => i.value === this.val);
            return item || this.items[0];
        },

        selectableItems() {
            if (this.nullable) return this.items;
            return this.items.filter(i => i.value.length > 0);
        },

        filteredItems() {
            let query = this.query.toLowerCase();
            return this.selectableItems.filter(i => {
                return !query || i.title?.toLowerCase().includes(query) || i.desc?.toLowerCase().includes(query);
            });
        },

    },

    methods: {

        selectItem(val) {
            this.val = val;
            this.hideMenu();
            this.$emit('input', val);
        },

        hideMenu() {
            this.show = false;
        },

    },

}

</script>
